module.exports = __webpack_public_path__ + "static/media/concept-7-sm-2.e9655bfa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/union-square/concept-7-sm-2.jpg
// module id = 4464
// module chunks = 15